import gql from "graphql-tag";

export const casesTableFieldsFragment = gql`
	fragment GetCasesFields on CaseTableRow {
		id
		order
		formattedContent
		status
		lastStatusChangeDate
		lastFinancialUpdateDate
		actualAgreementId
		documentStatus
		sourceTenantId
		patientInsuranceId
		patientInitials
		agreementName
		preparationBrandName
		preparationGenericName
		totalAmount
		canUserViewFinancials
		agreementId
		currencyCode
		currencyName
		participatingCounterpartyNames
		formattedIndications
		currentReviewerNames
		counterpartyInReview
		suspensionReason
	}
`;

export const agreementsTableFieldsFragment = gql`
	fragment GetAgreementsFields on AgreementTableRow {
		id
		order
		formattedContent
		canUserViewFinancials
		name
		validFromDate
		validToDate
		lastVersionValidToDate
		lastVersionStatus
		formattedValidityPeriod
		formattedIndications
		formattedDiseases
		formattedProducts
		formattedCounterparties
		formattedTags
		agreementTagTypes
		status
		totalAmount
		currencyCode
		currencyName
		daysToExpiry
	}
`;

export const refundsTableFieldsFragment = gql`
	fragment GetRefundsFields on RefundTableRow {
		id
		order
		formattedContent
		documentStatus
		documentId
		documentRefundGroupId
		documentIsConfirmedBySeller
		documentIsConfirmedByBuyer
		agreementId
		purchaseOrPatientId
		caseOrAgreementId
		tenantIds
		nonObserverTenantIds
		canUserModifyFinancials
		creatableDocument
		caseId
		createdOn
		status
		smartMipStatus
		currentReviewerOrganization
		formattedTags
		agreementName
		product
		iin
		amount
		adjustedAmount
		adjustedRate
		adjustedBy {
			id
			firstName
			lastName
			_dbNodeId
		}
		lastAdjustedAt
		adjustmentComment
		finalAmount
		finalRefundablePercentage
		refundRate
		currency
		counterParties
		isAgreementBuyer
		isAgreementSeller
		dataPointUuid
		basePrice
		refundablePercentage
		prescriptionDate
		quantity
		isDelta
		evaluationSnapshot
		invoiceDate
		invoiceNumber
		insuranceClaimId
		rating
		recordTypeLocalizationKey
		treatmentName
		treatmentCountryName
		treatmentPreparationBrandName
		treatmentPreparationDescriptionDe
		legalEntityName
		currencyName
		agreementTagTypes
		predecessorIds
		canBeReplacedInDocumentIds
		canBeReplacementInDocumentIds
		successorIds
		removedFromDocumentId
	}
`;

export const documentsTableFieldsFragment = gql`
	fragment GetDocumentsFields on DocumentTableRow {
		id
		smartMipReimbursementId
		order
		formattedContent
		status
		type
		coveragePeriod
		coveragePeriodStart
		coveragePeriodEnd
		periodDateType
		counterParties
		formattedTags
		product
		isAgreementBuyer
		currentReviewerOrganization
		currentReviewerOrganizationOrEmptyString
		createdOn
		invoiceAmount
		adjustedInvoiceAmount
		isConfirmedBySeller
		currency
		agreementIds
		agreementWithoutUserAccessNames
		agreementTagTypes
		finalInvoiceAmount
		issuedOn
		lastRemindedOn
		sentToReviewOn
		reviewRemindedOn
		beneficiary
		paymentReferenceLyfegen
		paymentReceiptPayer
		isSentToSmartMip
		formattedApprovers
	}
`;

export const formsTableFieldsFragment = gql`
	fragment GetFormsFields on FlexEntity {
		id
		createdOn
		status
		decisionTherapy
		occurrence
		containerType
		flexEntityName
		patientId
		createdByName
		preparationBrandNames
		preparationGenericNames
		createdByEmail
		viewCreatedByName
		viewFormattedContentEn
		viewFormattedContentDe
		externalFormId
	}
`;

export const recordsTableFieldsFragment = gql`
	fragment GetRecordsFields on Record {
		id
		type
		flexEntityName
		status
		insuranceId
		purchaseId
		purchaseOrPatientId
		preparationBrandNames
		preparationGenericNames
		preparationId
		occurrence
		createdOn
		createdByEmail
		createdByName
		claimId
		administrationDate
		purchaseDate
		prescriptionDate
		viewSuccessorId
		viewCaseId
		viewSourceRefundStatus
		viewCases
		viewDate
		viewFormattedContentEn
		viewFormattedContentDe
	}
`;

export const questsTableFieldsFragmentWithRecords = gql`
	fragment GetQuestsFieldsWithRecords on QuestTableRow {
		id
		order
		formattedContent
		value
		timeStamp
		completionStatus
		triggerEventId
		questStatus
		brandName
		patientsNo
		recordsCompleted
		recordsCount
		resolvedByName
		questOwnerName
		records {
			_dbNodeId
			id
			quantity
			insuranceId
			administrationDate
		}
		questOwner {
			id
			email
			firstName
			lastName
		}
	}
`;

export const questsTableFieldsFragmentWithoutRecords = gql`
	fragment GetQuestsFieldsWithoutRecords on QuestTableRow {
		id
		order
		formattedContent
		value
		timeStamp
		completionStatus
		triggerEventId
		questStatus
		brandName
		patientsNo
		recordsCompleted
		recordsCount
		resolvedByName
		questOwnerName
		questOwner {
			id
			email
			firstName
			lastName
		}
	}
`;
